import styled, { css } from 'styled-components';

import { iconFill } from '../../styles/mixin';
import { Clickable } from '../Clickable';
import { Icon } from '../Icon';

export const StyledIcon = styled(Icon)`
    margin: 0;
    width: 1rem;
    height: 1rem;
    transform: rotateY(180deg);
    transition: all ${({ theme }) => theme.transitions.hover};
`;

export const StyledButton = styled(Clickable)`
    width: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    justify-content: flex-start;
    column-gap: 0.25rem;
    ${({ theme }) => css`
        font-size: ${theme.fontSizes[4]};
        &:hover {
            ${StyledIcon} {
                ${iconFill(theme.colors.logoPrimary)};
            }
        }
    `}
`;
